<template>
	<section class="small-12 large-7 register flex justify-center animated fadeIn">
		<div class="small-12 large-7">
			<div class="small-12 socialSignUp">
				<h2 class="small-12 columns">Forget something?</h2>
			</div>
			<div class="small-12 emailSignUp">
				<form class="small-12 float-left userSignIn" v-on:submit.prevent="onSubmit">
					<fieldset class="small-12 columns">
						<label>Email</label>
						<input type="email" name="email" v-model="email" required>
					</fieldset>
					<div class="small-12 columns action flex vertical-align">
						<a class="primaryButton borderRadius50 flex justify-center" @click="sendEmail()">
							Reset My Password
						</a>
						<p class="auto"> 
							<router-link :to="{ name: 'SignIn' }">
								Nevermind, I remember.
							</router-link>
						</p>
					</div>
				</form>
			</div>
		</div>
	</section>
</template>

<script>

	// Import firebase services
    import { firebaseAuth } from '@/firebase/firebase-config'

    // Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'ForgotPasswordForm',

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			SpinnerMethods

		],

		/*
		**  Set up the data
		*/

		data: () => ({

			email: null

		}),

		/*
		**  Set up the methods
		*/

		methods: {

			onSubmit: function() {

				// Do nothing

			},

			validate: function() {

				if (!this.email) return 'An email address is required.';

			},

			sendEmail: function() {

				// Validate the fields
				let validation = this.validate();

				// Return validation error
				if (validation) {

					// Throw error message
				    this.$swal('Uh Oh!', validation, 'error');

				    return;

				}

    			// Show the spinner
    			this.showSpinner();

    			// Create the user in firestore
				firebaseAuth.sendPasswordResetEmail(this.email)
				.then(() => {

					// Clear the user input
					this.email = null;

					// Hide the spinner
					this.hideSpinner();

					// Throw success message
		    		this.$swal('Success!', 'Please check your email account. We have sent a little something on over to you.', 'success');

				})
				.catch(error => {

					// Hide the spinner
					this.hideSpinner();

					// Throw warning message
	    			this.$swal('Uh Oh!', error.message, 'error');

	    			// Send to bugsnag
					this.reportNoAuthBugsnagError({
						title: 'SISU - Send Password Reset Email',
						errorType: 'Firebase Auth',
						section: 'SISU',
						component: 'ForgotPasswordForm',
						error: error
					});

				});

			}

		}

	}

</script>